import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { useSelectedObjects } from '../../hooks/useSelectedObjects';
import { ActionIcons } from '../../Iconography';
import { DialogWrapper } from '../common/DiaglogWrapper';
import { ContextQueryModal } from '../factories/ContextQuery/contextQueryModalV2';
import { getDataGridProps } from '../NetworkSystem/NetworkMonitoriingTableView/selection/getDeviceSelectionDataGridProps';
import { componentParamPairsMap } from '../NetworkSystem/NetworkMonitoriingTableView/selection/parameterDefsV2';
const DeviceSelection = (props) => {
    const { visible, close, selectedDevices, setSelectedDevices } = props;
    const parentTableUseSelectedObjects = useSelectedObjects(selectedDevices, selectedDevices);
    const lastSearchedItemsRef = useRef([]);
    const lastQueryComponentKeyRef = useRef(undefined);
    const lastQueryParamsRef = useRef(undefined);
    const { state: [[choosenDevices]], } = parentTableUseSelectedObjects;
    return (_jsx(DialogWrapper, { header: 'Device Selection',
        open: visible,
        action: 'Select',
        actionIcon: _jsx(ActionIcons.Confirm, {}),
        setClosed: (actioned) => {
            if (actioned) {
                setSelectedDevices(choosenDevices);
            }
            close();
        }, children: _jsx(ContextQueryModal, { componentParamPairsMap,
            parentTableUseSelectedObjects,
            getDataGridProps,
            lastSearchedItemsRef,
            lastQueryComponentKeyRef,
            lastQueryParamsRef }) }));
};
export default DeviceSelection;
